interface Plan {
  years: number;
  months?: number;
}

export const getPlanDuration = (plan: Plan): string => {
  return plan.months ? `${plan?.years}.${plan.months}` : `${plan?.years}`;
};
